import React, { useEffect, useState } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { generatePageList } from 'utils';

const MarketingStepper = () => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const batchData = useSelector((state) => state.communicationBatching);
  const {
    communicationTypes,
    textContent,
    pushContent,
    emailTemplateId,
    fileName,
    batchName,
    scheduledTime,
    batchId,
  } = batchData;

  useEffect(() => {
    const PAGELIST = generatePageList(batchId, communicationTypes);
    const { pathname } = location;
    const idx = PAGELIST.findIndex(({ link }) => link === pathname);
    setCurrentStep(idx);
  }, []);
  return (
    <div className="mx-5 my-10">
      <Stepper
        activeStep={currentStep}
        style={{ backgroundColor: "transparent" }}
        alternativeLabel
      >
        <Step completed={!!batchName && !!scheduledTime}>
          <StepLabel>
            <p className={`text-${ !batchName || scheduledTime ? "black" : "gray"}}-500`}>
              Create batch message
            </p>
          </StepLabel>
        </Step>
        {communicationTypes.email && (
          <Step completed={!!emailTemplateId}>
            <StepLabel>
              <p className={`text-${ emailTemplateId ? "black" : "gray"}}-500`}>
                Select Email Template
              </p>
            </StepLabel>
          </Step>
        )}
        {communicationTypes.text && (
          <Step completed={!!textContent}>
            <StepLabel>
              <p className={`text-${ textContent ? "black" : "gray"}}-500`}>
                Setup Text Message
              </p>
            </StepLabel>
          </Step>
        )}
        {communicationTypes.push && (
          <Step completed={!!pushContent}>
            <StepLabel>
              <p className={`text-${pushContent ? "black" : "gray"}}-500`}>
                Setup Push Notification
              </p>
            </StepLabel>
          </Step>
        )}
        <Step completed={!!fileName}>
          <StepLabel>
            <p className={`text-${ fileName ? "black" : "gray"}}-500`}>
                Drop Csv
            </p>
          </StepLabel>
        </Step>
        <Step>
          <StepLabel>
            <p className={`text-${"black"}}-500`}>
              Review
            </p>
          </StepLabel>
        </Step>
      </Stepper>
    </div>
  );
};

export default MarketingStepper;
